import { render, staticRenderFns } from "./serviceTask.vue?vue&type=template&id=2813be3b&scoped=true"
import script from "./serviceTask.vue?vue&type=script&lang=js"
export * from "./serviceTask.vue?vue&type=script&lang=js"
import style0 from "./serviceTask.vue?vue&type=style&index=0&id=2813be3b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2813be3b",
  null
  
)

export default component.exports